import TileWrapper from '../TileWrapper'
import { Link } from 'react-router-dom'
import { useTeam } from 'app/frontend/base/config/context/team'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

dayjs.extend(relativeTime)

import { useOverviewData } from 'app/frontend/base/config/queries'
import { useTile } from '../../context'
import NewsItem from '../../../TeamNews/components/NewsItem'

const RecentNewsTile = () => {
  const { team } = useTeam()
  const { tile } = useTile()
  const { data: overviewData } = useOverviewData(team.id)
  const newsItems = overviewData?.newsItems || []

  const visibleNewsItems = newsItems.slice(0, tile.config?.amount || 2)

  if (tile.position === 'sidebar') {
    return (
      <TileWrapper>
        <ul className='space-y-3'>
          {visibleNewsItems.length === 0 ? (
            <p className='text-muted-foreground'>No news items found.</p>
          ) : null}

          {visibleNewsItems.map((item) => (
            <li
              key={item.id}
              className={'border-t pt-2 first:pt-0 first:border-t-0'}
            >
              <Link
                to={`${team.path}/news/${item.id}`}
                className='flex justify-between gap-3 group'
              >
                <div>
                  <p className='font-medium group-hover:text-primary transition-colors'>
                    {item.title}
                  </p>
                  <p className='text-sm text-muted-foreground'>
                    {dayjs(item.firstPublishedAt).fromNow()}
                  </p>
                </div>

                {item.mainImageUrl && (
                  <img
                    src={item.mainImageUrl}
                    alt={item.title}
                    className='h-10 object-cover rounded-md border'
                  />
                )}
              </Link>
            </li>
          ))}
        </ul>
      </TileWrapper>
    )
  }

  return (
    <TileWrapper inContainer={false}>
      <div className='flex flex-col space-y-4'>
        {visibleNewsItems.map((item) => (
          <NewsItem key={item.id} item={item} inList={true} />
        ))}
      </div>
    </TileWrapper>
  )
}

export default RecentNewsTile
